import { createReducer } from "sc/helpers/reducer";
import { LOGIN, IMPERSONATE, STOP_IMPERSONATING } from "../actions/auth";

export default createReducer(null, {
  [IMPERSONATE]: (state, action) => action.payload.partnerId,
  [STOP_IMPERSONATING]: (state, action) => null,
  [LOGIN]: (state, action) => null,
});



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/reducers/impersonated-partner-reducer.js